// services/assessmentService.js

import API from "../api/api";

export const assessmentService = {
  getAssessments: async () => {
    const response = await API.get('/get_assessments');
    return response.data.data || [];
  },
  getAssessmentSessions: async () => {
    const response = await API.get('/get_assessment_sessions');
    return response.data.data || [];
  },
  getAssessmentQuestions: async (assessmentId) => {
    const response = await API.get('/get_assessment_questions', {
      params: { assessment_id: assessmentId }
    });
    return response.data.data || [];
  },
  deleteAssessment: async (id) => {
    const response = await API.post('/delete_assessment', { id });
    return response.data;
  },
};